<crowdctrl-page
  [pageTitle]="(pageTitle$ | async) ?? 'Welcome'"
  [contentClass]="'home-page-content'"
>
  <div class="home-header">
    <h1>{{ appName }}</h1>
    <p class="home-subtitle">{{ appSubtitle }}</p>
  </div>

  <div class="dashboard-tiles">
    <button type="button" class="service-tile disabled" aria-disabled="true">
      <ion-icon name="list-outline" class="tile-icon"></ion-icon>
      <span class="tile-label">My Active Sessions</span>
    </button>
    <button type="button" class="service-tile disabled" aria-disabled="true">
      <ion-icon name="briefcase-outline" class="tile-icon"></ion-icon>
      <span class="tile-label">My Active Workspaces</span>
    </button>
    <button
      type="button"
      class="service-tile"
      [class.disabled]="isNavigating"
      [class.selected]="selectedTilePath === 'manage'"
      (click)="navigateToManageWorkspaces($event)"
    >
      @if (selectedTilePath === 'manage') {
        <ion-spinner name="crescent" class="tile-icon"></ion-spinner>
      } @else {
        <ion-icon name="folder-open-outline" class="tile-icon"></ion-icon>
      }
      <span class="tile-label">Manage Workspaces</span>
    </button>
    <a
      href="/settings"
      class="service-tile"
      [class.disabled]="isNavigating"
      [class.selected]="selectedTilePath === '/settings'"
      (click)="navigateTo('/settings', $event)"
    >
      @if (selectedTilePath === '/settings') {
        <ion-spinner name="crescent" class="tile-icon"></ion-spinner>
      } @else {
        <ion-icon name="settings-outline" class="tile-icon"></ion-icon>
      }
      <span class="tile-label">Settings</span>
    </a>
    @if (showDownloadAndroid) {
      <a
        href="/download"
        class="service-tile"
        [class.disabled]="isNavigating"
        [class.selected]="selectedTilePath === '/download'"
        (click)="navigateTo('/download', $event)"
      >
        @if (selectedTilePath === '/download') {
          <ion-spinner name="crescent" class="tile-icon"></ion-spinner>
        } @else {
          <ion-icon name="logo-android" class="tile-icon"></ion-icon>
        }
        <span class="tile-label">Get Android app</span>
      </a>
    }
    <button
      type="button"
      class="service-tile"
      [class.disabled]="isNavigating"
      [class.selected]="selectedTilePath === 'signout'"
      (click)="signOutFromTile($event)"
    >
      @if (selectedTilePath === 'signout') {
        <ion-spinner name="crescent" class="tile-icon"></ion-spinner>
      } @else {
        <ion-icon name="log-out-outline" class="tile-icon"></ion-icon>
      }
      <span class="tile-label">Sign out</span>
    </button>
  </div>
</crowdctrl-page>
